// --------------------------------------------------------------------------
// #90 – Homes activity map
//     - specifically handles the styling (on mobile devices) of the
//       filters for the map
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------


'use strict';

module.exports = function (options) {
    var context = options.context;

    // show hide filters variables
    var mainLabel = context.find('[data-binding="filter-main-label"]');
    var filterWrapper = context.find('[data-binding="filter-wrapper"]');

    /**
     * Init the module, attach any event listener
     */
    function init() {

        var mql = window.matchMedia('screen and (max-width: 960px)');

        function handleMatchMedia(mql) {
            if (mql.matches) {
                mainLabel.on('click', function (e) {
                    e.preventDefault();
                    filterWrapper.toggleClass('active');
                });
            } else {
                mainLabel.off('click');
            }
        }

        handleMatchMedia(mql);
        mql.addListener(handleMatchMedia);
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activities-map-filters.js
// module id = 203
// module chunks = 0